import { map } from 'rxjs/operators';
import { BehaviorSubject, combineLatest } from 'rxjs';
import { Vector2 } from 'three';
import {
  Component,
  AfterViewInit,
  Renderer2,
  ElementRef,
  Input,
} from '@angular/core';
import { drawArrow } from '../share/plot';

@Component({
  selector: 'app-info',
  templateUrl: './info.component.html',
  styleUrls: ['./info.component.css'],
})
export class InfoComponent implements AfterViewInit {
  // model = new RingModel(new Vector3(0, 0, 0), 29.9, 30);
  canvas_width = 300;
  canvas_height = 300;
  private infoSubject = new BehaviorSubject<any[]>(['hello']);
  private positionSubject = new BehaviorSubject<Vector2>(
    new Vector2(this.canvas_width / 2, this.canvas_height / 2),
  );
  info_position: Vector2;
  arrow_position: Vector2;
  distance = 10;
  cans: HTMLCanvasElement;
  ctx: CanvasRenderingContext2D;
  info$ = this.infoSubject.asObservable();
  position$ = this.positionSubject.asObservable();

  @Input()
  get info(): any[] {
    return this.infoSubject.value;
  }
  set info(i: any[]) {
    this.infoSubject.next(i);
  }
  @Input()
  get position(): Vector2 {
    return this.positionSubject.value;
  }
  set position(p: Vector2) {
    this.positionSubject.next(p);
  }

  @Input() arrow_enable = true;
  @Input() info_style;
  constructor(private renderer: Renderer2, private el: ElementRef) {
    this.cans = this.renderer.createElement('canvas') as HTMLCanvasElement;
    this.cans.height = this.canvas_height;
    this.cans.width = this.canvas_width;
    this.ctx = this.cans.getContext('2d');
    this.ctx.fillStyle = 'red';
    this.ctx.fillText('txt', 100, 100);
    this.renderer.appendChild(this.el.nativeElement, this.cans);
    const drawer = combineLatest(this.info$, this.position$)
      .pipe(
        map(d => {
          // console.log('position', d[1]);
          const p = this.getDirection(d[1]);
          if (this.arrow_enable) {
            const start = new Vector2(
              ((d[1].x + 40) / 80) * 300,
              ((d[1].y + 30) / 60) * 300,
            );
            const end = new Vector2(p.x - 5, p.y - 5);
            // console.log('p',p);
            this.ctx.clearRect(0, 0, this.canvas_width, this.canvas_height);
            drawArrow(this.ctx, start, end);
          }
          let k = 0;
          while (k < d[0].length) {
            this.ctx.fillText(
              d[0][k],
              // this.info_position.x,
              p.x,
              // this.info_position.y + k * this.distance,
              p.y + k * this.distance,
            );
            k++;
          }
        }),
      )
      .subscribe(
        () => this.renderer.appendChild(this.el.nativeElement, this.cans),
        console.error,
      );
    // this.getDirection(this.position);
    // this.info$
    //   .pipe(
    //     map(i => {
    //       this.ctx.clearRect(0, 0, this.canvas_width, this.canvas_height);
    //       let k = 0;
    //       while (k < i.length) {
    //         this.ctx.fillText(
    //           i[k],
    //           this.info_position.x,
    //           this.info_position.y + k * this.distance,
    //         );
    //         k++;
    //       }
    //     }),
    //   )
    //   .subscribe(
    //     () => this.renderer.appendChild(this.el.nativeElement, this.cans),
    //     console.error,
    //   );
  }

  ngOnInit() {}

  ngAfterViewInit(): void {
    //   this.getDirection(this.position);
    //   const cans = this.renderer.createElement('canvas') as HTMLCanvasElement;
    //   cans.height = this.canvas_height;
    //   cans.width = this.canvas_width;
    //   const ctx = cans.getContext('2d');
    //   ctx.lineWidth = 0.5;
    //   ctx.fillStyle = 'tomato';
    //   ctx.font = '10px Microsoft JhengHei';
    //   let i = 0;
    //   while (i < this.info.length) {
    //     ctx.fillText(
    //       this.info[i],
    //       this.info_position.x,
    //       this.info_position.y + i * this.distance,
    //     );
    //     i++;
    //   }
    //   // this.renderer.appendChild(this.el.nativeElement, cans);
    //   // ctx.clearRect(0,0,300,300);
    //   // this.renderer.appendChild(this.el.nativeElement, this.cans);
  }

  getDirection(position: Vector2) {
    const w = this.canvas_width;
    const h = this.canvas_height;
    const x = ((position.x + 40) / 80) * 300; // scence position to client position
    const y = ((position.y + 30) / 60) * 300;
    // console.log('p', position, x, y);
    let result: Vector2;
    if (
      // bottom-right
      (y <= h / 6 && x <= w / 6) || // (1,1)
      (y >= h / 6 && y <= h / 2 && x >= h / 6 && x <= h / 2) // (2,2)
    ) {
      this.info_position = new Vector2(x + w / 6, y + h / 6);
      this.arrow_position = new Vector2(x + w / 6, y + h / 6);
      result = new Vector2(x + w / 6, y + h / 6);
    } else if (
      // bottom-left
      (y <= h / 6 && x >= (w / 6) * 5) || // (1,4)
      (y >= h / 6 && y <= h / 2 && x > w / 2 && x <= (w / 6) * 5) // (2,3)
    ) {
      this.info_position = new Vector2(x - w / 6, y + h / 6);
      this.arrow_position = new Vector2(x - w / 6, y + h / 6);
      result = new Vector2(x - w / 6, y + h / 6);
    } else if (
      // top-right
      (y >= (h / 6) * 5 && x <= w / 6) || // (4,1)
      (y > h / 2 && y <= (h / 6) * 5 && x >= h / 6 && x <= h / 2) // (3,2)
    ) {
      this.info_position = new Vector2(x + w / 6, y - h / 6);
      this.arrow_position = new Vector2(x + w / 6, y - h / 6);
      result = new Vector2(x + w / 6, y - h / 6);
    } else if (
      // top-left
      (y >= (h / 6) * 5 && x >= (w / 6) * 5) || // (4,4)
      (y >= h / 2 && y < (h / 6) * 5 && x >= w / 2 && x < (w / 6) * 5) // (3,4)
    ) {
      this.info_position = new Vector2(x - w / 6, y - h / 6);
      this.arrow_position = new Vector2(x - w / 6, y - h / 6);
      result = new Vector2(x - w / 6, y - h / 6);
    } else if (
      // right
      y > h / 6 &&
      y < (h / 6) * 5 &&
      x <= w / 6 // (2,1) && (3,1)
    ) {
      this.info_position = new Vector2(x + w / 6, y);
      this.arrow_position = new Vector2(x + w / 6, y);
      result = new Vector2(x + w / 6, y);
    } else if (
      // left
      y > h / 6 &&
      y < (h / 6) * 5 &&
      x >= (w / 6) * 5 // (2,4) && (3,4)
    ) {
      this.info_position = new Vector2(x - w / 6, y);
      this.arrow_position = new Vector2(x - w / 6, y);
      result = new Vector2(x - w / 6, y);
    } else if (
      // top
      y >= (h / 6) * 5 &&
      x > w / 6 &&
      x < (w / 6) * 5 // (4,2) && (4,3)
    ) {
      this.info_position = new Vector2(x, y - h / 6);
      this.arrow_position = new Vector2(x, y - h / 6);
      result = new Vector2(x, y - h / 6);
    } else if (
      // bottom
      y <= h / 6 &&
      x > w / 6 &&
      x < (w / 6) * 5 // (1,2) && (1,3)
    ) {
      this.info_position = new Vector2(x, y + h / 6);
      this.arrow_position = new Vector2(x, y + h / 6);
      result = new Vector2(x, y + h / 6);
    }
    return result;
  }
}
